/** Presentation only. This dismissal never satisfies MFA or changes access. */
export function mfaReminderDismissalCookie(userId: string): string {
  return `statura-mfa-reminder-${encodeURIComponent(userId)}`;
}

export type MfaReminderSeed = {
  userId: string;
  needsMfa: boolean;
  dismissed: boolean;
  hostSuppressed: boolean;
};
